import React from "react";
import Pagetitle from "../elements/Pagetitle";
import PaperOrganizer from "../elements/PaperOrganizer";
import TrackVisibility from "react-on-screen";
import Winner from "../elements/Winner";

const papersData = [
    {
        id: 1,
        title: "Sequential Harmful Shift Detection Without Labels",
        category: ["Distribution Shift / Domain Adaptation", "Selected papers"],
        filesource: "../../papers/shsd.md",
        date: "09 Dec, 2024",
        author: (
            <>
                <b>Salim I. Amoukou</b>, Tom Bewley, Saumitra Mishra, Freddy Lecue, Daniele Magazzeni, Manuela Veloso
            </>
        ),
        // github: "https://github.com/salimamoukou/",
        pdf: "https://openreview.net/pdf?id=jps9KkuSD3",
        source: (<span style={{ color: 'rgb(250, 77, 96)', fontWeight: 'bold' }}>NeurIPS 2024</span>),
    },
    {
        id: 2,
        title: "Counterfactual Metarules for Local and Global Recourse",
        category: ["Explainable AI"],
        filesource: "../../papers/counterfactual_rules.md",
        date: "29 May, 2024",
        author: (
            <>
                Tom Bewley, <b>Salim I. Amoukou</b>, Saumitra Mishra, Daniele Magazzeni, Manuela Veloso
            </>
        ),
        // github: "https://github.com/salimamoukou/",
        pdf: "https://arxiv.org/pdf/2405.18875",
        source: (<span style={{ color: 'rgb(250, 77, 96)', fontWeight: 'bold' }}>ICML 2024</span>)
    },
    {
        id: 3,
        title: "Rethinking Counterfactual Explanations as Local and Regional Counterfactual Policies",
        category: ["Explainable AI"],
        filesource: "../../papers/rethinking_counterfactuals.md",
        date: "16 May, 2022",
        author: (
            <>
                <b>Salim I. Amoukou</b>, Nicolas J-B. Brunel
            </>
        ),
        // github: "https://github.com/salimamoukou/acv00",
        pdf: "https://arxiv.org/abs/2209.14568",
        source: (<span style={{ color: 'rgb(250, 77, 96)', fontWeight: 'bold' }}>ICML 2023 Workshop on Counterfactuals in Minds and Machines</span>),
    },
    {
        id: 4,
        title: "Consistent Sufficient Explanations and Minimal Local Rules for explaining regression and classification models",
        category: ["Explainable AI", "Selected papers"],
        filesource: "../../papers/consistent_explanations.md",
        date: "08 November, 2021",
        author: (
            <>
                <b>Salim I. Amoukou</b>, Nicolas J-B. Brunel
            </>
        ),
        github: "https://github.com/salimamoukou/acv00",
        pdf: "https://arxiv.org/pdf/2111.04658",
        source: (<span style={{ color: 'rgb(250, 77, 96)', fontWeight: 'bold' }}>NeurIPS 2022</span>),
    },
    {
        id: 5,
        title: "Adaptive Conformal Prediction by Reweighting Nonconformity Score",
        category: ["Uncertainty Quantification / Conformal Prediction"],
        filesource: "../../papers/adaptive_conformal_prediction.md",
        date: "26 Jan, 2023",
        author: (
            <>
                <b>Salim I. Amoukou</b>, Nicolas J-B. Brunel
            </>
        ),
        github: "https://github.com/salimamoukou/ACPI",
        pdf: "https://arxiv.org/pdf/2303.12695.pdf",
        source: (<b></b>),
    },
    {
        id: 6,
        title: "Regional Explanations: Bridging Local and Global Variable Importance",
        category: ["Explainable AI", "Selected papers"],
        filesource: "../../papers/regional.md",
        date: "Jun, 2024",
        author: (
            <>
                <b>Salim I. Amoukou</b>, Nicolas J-B. Brunel
            </>
        ),
        pdf: "https://openreview.net/pdf?id=ubrecCeZrc",
        source: (<span style={{ color: 'rgb(250, 77, 96)', fontWeight: 'bold' }}>NeurIPS 2025</span>),
    },
    {
        id: 7,
        title: "Accurate and robust Shapley Values for explaining predictions and focusing on local important variables",
        category: ["Explainable AI"],
        filesource: "../../papers/accurate_and_robust.md",
        date: "07 June, 2021",
        author: (
            <>
                <b>Salim I. Amoukou</b>, Nicolas J-B. Brunel
            </>
        ),
        github: "https://github.com/salimamoukou/acv00",
        pdf: "https://arxiv.org/abs/2106.03820",
        source: (<span style={{ color: 'rgb(250, 77, 96)', fontWeight: 'bold' }}>AISTATS 2022</span>),
    },
    {
        id: 8,
        title: "Trustworthy machine learning : explainability and distribution-free uncertainty quantification",
        category: ["Thesis"],
        filesource: "../../papers/thesis.md",
        date: "15 Dec, 2023",
        author: (
            <>
                <b>Salim I. Amoukou</b>
            </>
        ),
        github: "https://theses.hal.science/tel-04485328",
        pdf: "https://theses.hal.science/tel-04485328",
        source: (<span style={{ color: 'rgb(250, 77, 96)', fontWeight: 'bold' }}>University Paris Saclay</span>),
    },
    {
        id: 9,
        title: "To Steer or Not to Steer? Mechanistic Error Reduction with Abstention for Language Models",
        category: ["LLM Safety", "Selected papers"],
        filesource: "../../papers/tosteer.md",
        date: "15 Oct, 2025",
        author: (
            <>
                Anna Hedstrom, <b>Salim I. Amoukou</b>, Tom Bewley, Saumitra Mishra, Manuela Veloso
            </>
        ),
        github: "https://github.com/annahedstroem/MERA-steering",
        pdf: "https://arxiv.org/pdf/2510.13290",
        source: (<span style={{ color: 'rgb(250, 77, 96)', fontWeight: 'bold' }}>ICML 2025</span>),
    },
    {
        id: 10,
        title: "Representation Consistency for Accurate and Coherent LLM Answer Aggregation",
        category: "LLM Safety",
        filesource: "../../papers/llm_consistency.md",
        date: "3 Nov, 2025",
        author: (
            <>
                Junqi Jiang, Tom Bewley, <b>Salim I. Amoukou</b>, Francesco Leofante, Antonio Rago, Saumitra Mishra, Francesca Toni
            </>
        ),
        pdf: "https://arxiv.org/pdf/2506.21590",
        source: (<span style={{ color: 'rgb(250, 77, 96)', fontWeight: 'bold' }}>NeurIPS 2025</span>),
    },
    {
        id: 11,
        title: "Entropic Projection Alignment: Estimating, Explaining, and Improving Model Performance Under Tabular Distribution Shift",
        category: ["Distribution Shift / Domain Adaptation", "Selected papers"],
        filesource: "../../papers/epa.md",
        date: "3 Feb, 2026",
        author: (
            <>
                <b>Salim I. Amoukou</b>, Emanuele Albini, Tom Bewley, Saumitra Mishra, Manuela Veloso
            </>
        ),
        pdf: "https://arxiv.org/pdf/2605.31250",
        source: (<span style={{ color: 'rgb(250, 77, 96)', fontWeight: 'bold' }}>AISTATS 2026</span>),
    },
    {
        id: 12,
        title: "Adaptive Random Forests from Online Learning and Testing by Betting",
        category: ["Online Learning", "Selected papers"],
        filesource: "../../papers/orf.md",
        date: "Coming soon",
        author: (
            <>
                <b>Salim I. Amoukou</b>, Saumitra Mishra, Manuela Veloso
            </>
        ),
        source: (<span style={{ color: 'rgb(250, 77, 96)', fontWeight: 'bold' }}>Still baking 🍞</span>),
    },
    {
        id: 13,
        title: "Correcting Split Selection in Online Decision Trees via Anytime-Valid Inference",
        category: ["Online Learning", "Selected papers"],
        filesource: "../../papers/odt.md",
        date: "28 Jun, 2026",
        author: (
            <>
                <b>Salim I. Amoukou</b>, Saumitra Mishra, Manuela Veloso
            </>
        ),
        pdf: "https://arxiv.org/pdf/2605.31239v1",
        source: (<span style={{ color: 'rgb(250, 77, 96)', fontWeight: 'bold' }}> Spotlight ICML 2026</span>),
    },

];

const winnerData = [
    {
        id: 1,
        title: "1st Place - Hackathon on Explainability",
        organization: "ACPR (Autorité de Contrôle Prudentiel et de Résolution)",
        description: "1st place at the Hackathon on the explainability of risk scoring models",
        link: "https://www.linkedin.com/posts/slim-amk_fintech-innovation-techsprint-activity-6817737034778603520-9h3J",
        linkText: "View on LinkedIn",
        icon: "icon-trophy",
    },
    {
        id: 2,
        title: "Best Young Statistician Presentation Award",
        organization: "ENBIS Spring Meeting 2024",
        description: "Recognition for outstanding presentation at the European Network for Business and Industrial Statistics conference",
        link: "https://conferences.enbis.org/event/45/page/60-news",
        linkText: "View Award",
        icon: "icon-star",
    },
];

function Papers() {
    return (
        <section id="paper">
            <div className="container">
                <Pagetitle title="Papers" />
                <div className="row exp bg-white rounded shadow-dark padding-30 overflow-hidden">
                    <PaperOrganizer papersData={papersData} />
                </div>
            </div>
        </section>
    );
}

export default Papers;
